// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__Dc4hi","insightsList":"newBusinessInsightsMenu_insightsList__1qazQ","active":"newBusinessInsightsMenu_active__2LjOG"};